module.exports = __webpack_public_path__ + "static/img/hzhb_rb.63c1d68.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/hzhb_rb.png
// module id = 3ziK
// module chunks = 0